import Pagination from "react-bootstrap/Pagination";
import { useEffect, useMemo } from "react";

const CustomPagination = ({
  currentPage,
  totalPages,
  data = null,
  itemsPerPage = 12,
  onPageChange,
  onDataChange = null,
}) => {
  const totalPagesCount = useMemo(() => {
    return data ? Math.ceil(data.length / itemsPerPage) : totalPages;
  }, [data, itemsPerPage, totalPages]);

  const paginatedData = useMemo(() => {
    if (!data) return null;
    const startIndex = (currentPage - 1) * itemsPerPage;
    return data.slice(startIndex, startIndex + itemsPerPage);
  }, [data, currentPage, itemsPerPage]);

  useEffect(() => {
    if (onDataChange && paginatedData) {
      onDataChange(paginatedData);
    }
  }, [paginatedData, onDataChange]);

  const createPageItem = (page, isActive = false) => (
    <Pagination.Item
      key={page}
      active={isActive}
      onClick={() => onPageChange(page)}
    >
      {page}
    </Pagination.Item>
  );

  const renderPaginationItems = () => {
    const items = [];
    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage === totalPagesCount;

    items.push(
      <Pagination.First
        key="first"
        disabled={isFirstPage}
        onClick={() => onPageChange(1)}
      />,
      <Pagination.Prev
        key="prev"
        disabled={isFirstPage}
        onClick={() => onPageChange(currentPage - 1)}
      />
    );

    items.push(createPageItem(1, currentPage === 1));

    if (currentPage > 3) {
      items.push(<Pagination.Ellipsis key="ellipsis1" />);
    }

    const startPage = Math.max(2, currentPage - 1);
    const endPage = Math.min(totalPagesCount - 1, currentPage + 1);

    for (let page = startPage; page <= endPage; page++) {
      items.push(createPageItem(page, page === currentPage));
    }

    if (currentPage < totalPagesCount - 2) {
      items.push(<Pagination.Ellipsis key="ellipsis2" />);
    }

    if (totalPagesCount > 1) {
      items.push(
        createPageItem(totalPagesCount, currentPage === totalPagesCount)
      );
    }

    items.push(
      <Pagination.Next
        key="next"
        disabled={isLastPage}
        onClick={() => onPageChange(currentPage + 1)}
      />,
      <Pagination.Last
        key="last"
        disabled={isLastPage}
        onClick={() => onPageChange(totalPagesCount)}
      />
    );
    return items;
  };
  if (totalPagesCount <= 1) return null;

  return (
    <div className="d-flex justify-content-end mt-3">
      <Pagination>{renderPaginationItems()}</Pagination>
    </div>
  );
};

export default CustomPagination;
